import { render, staticRenderFns } from "./costHelpThirtyTage.vue?vue&type=template&id=72d871b8&"
import script from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d871b8')) {
      api.createRecord('72d871b8', component.options)
    } else {
      api.reload('72d871b8', component.options)
    }
    module.hot.accept("./costHelpThirtyTage.vue?vue&type=template&id=72d871b8&", function () {
      api.rerender('72d871b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lwl6DKV45z4A/JS/costHelpThirtyTage.vue"
export default component.exports